import { ModalState } from './RJCommunicationHub.types';

type DetermineNextStepParams = {
  hasEmail: boolean;
  isIndeedFlow: boolean;
  dontShowMessagePreview: boolean | null;
  dontShowQuestionnairePreview: boolean | null;
};

export const determineNextCommunicationStep = ({
  hasEmail,
  isIndeedFlow,
  dontShowMessagePreview,
  dontShowQuestionnairePreview,
}: DetermineNextStepParams) => {
  if ((isIndeedFlow || hasEmail) && !dontShowMessagePreview) {
    return ModalState.GENERATED_MESSAGE;
  }

  if (!dontShowQuestionnairePreview) {
    return ModalState.QUESTIONNAIRE_PREVIEW;
  }

  return ModalState.LOADING;
};
